module.exports = __webpack_public_path__ + "img/authe-1.ada4719.jpg";